import { Component, Input, OnInit } from '@angular/core';
import { HomeService } from '../../../pages/home/services/home.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-paperless-modal',
  templateUrl: './paperless-modal.component.html',
  styleUrls: ['./paperless-modal.component.css']
})
export class PaperlessModalComponent implements OnInit {
  @Input() data: any;
  @Input() portalSettings: any;
  mobileMode: boolean;
  processing: boolean = false;
  formData: { [key: string]: any } = {};
  postData: { [key: string]: any } = {};
  cellCarriers: any[] = [];
  inValidPhone: boolean;
  emptyCarrierList: boolean;
  carrierMissingMsg: string = 'Cell Phone Carrier is not set in Vista';
  allowInfoChange: boolean;
  showPaperlessCarrier: boolean;
  requirePersonalInfo: boolean;
  personalInfoLoaded: boolean;
  phoneMask: string;
  companyName: string;
  userAction: string;

  constructor(private homeService: HomeService, public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.mobileMode = this.mobileAndTabletcheck();
    this.allowInfoChange = this.portalSettings.AllowPaperlessInfoChange.ConfigValue == "1";
    this.showPaperlessCarrier = this.portalSettings.ShowPaperlessCarrier.ConfigValue == "1";
    this.requirePersonalInfo = this.portalSettings.PaperlessPersonalInfoRequire.ConfigValue == "1";
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue ? this.portalSettings.PhoneMask.ConfigValue.replace(/9/g, '_') : "";
    this.companyName = this.portalSettings.HRPortalName.ConfigValue;
    this.formData.EmployeeCountry = this.data.EmplCountry;
    this.formData.optOutSMS = this.data.OptOutSMS == true ? true : false;
    this.formData.showPayStub = this.portalSettings.ShowPaystubPaperless.ConfigValue == 1 ? true : false;
    this.formData.showW2 = this.portalSettings.ShowW2Paperless.ConfigValue == 1 ? true : false;
    this.formData.showC1095 = this.portalSettings.ShowC1095Paperless.ConfigValue == 1 ? true : false;
    this.formData.ElectronicPaystubConsent = this.data.ConsentPaystubs == true ? "1" : (this.data.ConsentPaystubs == false ? "0" : null);
    this.formData.W2DocumentConsent = this.data.ConsentW2T4 == true ? "1" : (this.data.ConsentW2T4 == false ? "0" : null);
    this.formData.C1095DocumentConsent = this.data.ConsentACA1095 == true ? "1" : (this.data.ConsentACA1095 == false ? "0" : null);
    this.formData.ElectronicPaystubVerbiage = this.portalSettings.ConsentPaystubsVerbiage.ConfigValue;
    this.formData.W2DocumentVerbiage = this.portalSettings.ConsentOtherDocsVerbiage.ConfigValue;
    this.formData.C1095DocumentVerbiage = this.portalSettings.ConsentC1095DocsVerbiage.ConfigValue;

    if (this.allowInfoChange) {
      this.homeService.getUserFields().then((response: any[]) => {
        var userFields = response;
        for (var i = 0; i < userFields.length; i++) {
          var field = userFields[i];
          if (field.FieldVPColumnName == "CellPhone" && field.FieldVPViewName != "HRDP") {
            if (field.PendingValue != null) {
              this.formData.CellPhoneOrig = field.PendingValue;
              this.formData.CellPhone = field.PendingValue;
              this.formData.CellPending = true;
              this.formData.CellPhoneFieldUpdateMode = field.FieldUpdateMode;
            }
            else {
              this.formData.CellPhoneOrig = field.FieldValue;
              this.formData.CellPhone = field.FieldValue;
              this.formData.CellPending = false;
              this.formData.CellPhoneFieldUpdateMode = field.FieldUpdateMode;
            }

            this.formData.CellLabel = field.FieldLabel;
          }
          if (field.FieldVPColumnName == "Email" && field.FieldVPViewName != "HRDP") {
            if (field.PendingValue != null) {
              this.formData.EmailOrig = field.PendingValue;
              this.formData.Email = field.PendingValue;
              this.formData.EmailPending = true;
              this.formData.EmailFieldUpdateMode = field.FieldUpdateMode;
            }
            else {
              this.formData.EmailOrig = field.FieldValue;
              this.formData.Email = field.FieldValue;
              this.formData.EmailPending = false;
              this.formData.EmailFieldUpdateMode = field.FieldUpdateMode;
            }

            this.formData.EmailLabel = field.FieldLabel;
          }
          if (field.FieldVPColumnName == "udCellPhoneCarrier" && field.FieldVPViewName != "HRDP") {
            if (field.PendingValue != null) {
              this.formData.CellCarrierOrig = field.PendingValue;
              this.formData.CellCarrier = field.PendingValue;
              this.formData.CellCarrierPending = true;
              this.formData.CellCarrierFieldUpdateMode = field.FieldUpdateMode;
            }
            else {
              this.formData.CellCarrierOrig = field.FieldValue;
              this.formData.CellCarrier = field.FieldValue;
              this.formData.CellCarrierPending = false;
              this.formData.CellCarrierFieldUpdateMode = field.FieldUpdateMode;
            }

            this.formData.CellCarrierLabel = field.FieldLabel;
            //238277: Remove the error message to be displayed
            this.carrierMissingMsg = null;
            this.getComboItems(field.FieldID);
          }
          this.personalInfoLoaded = true;
        }
      });
    }
  }

  mobileAndTabletcheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  validatePhone() {
    if (this.phoneMask != null) {
      var stringReplace = "/[\D\s]/gi";
      var maskLength = this.portalSettings.PhoneMask.ConfigValue.replace(stringReplace, '').length;
      var origVal = this.formData.CellPhone.replace(stringReplace, '');

      if (origVal.length != 0 && origVal.length < maskLength) {
        this.inValidPhone = true;
      } else {
        this.inValidPhone = false;
      }
    }
  }

  getComboItems(fieldID: any) {
    //hardcoded for just cell carriers, but can be modified to do more
    this.homeService.getComboItemsByFieldID(fieldID).then((response: any) => {
      this.cellCarriers = [];
      this.cellCarriers = this.cellCarriers.concat(response);

      if (this.cellCarriers.length == 0) {
        this.emptyCarrierList = true;
      }
    });
  }

  confirmClicked() {
    this.processing = true;
    if (this.allowInfoChange)
      this.updateInfo();
    else
      this.confirmSettings();
  }

  updateInfo() {
    this.postData = {};
    if (((this.allowInfoChange && this.formData.CellPhoneOrig == this.formData.CellPhone && this.formData.EmailOrig == this.formData.Email) || !this.allowInfoChange)
      && ((this.showPaperlessCarrier && this.formData.CellCarrierOrig == this.formData.CellCarrier) || !this.showPaperlessCarrier)) {
      this.confirmSettings();
    }
    else {
      if (this.allowInfoChange) {
        if (this.formData.CellPhoneOrig != this.formData.CellPhone) {
          this.postData.CellPhone = this.formData.CellPhone;
        }
        if (this.formData.EmailOrig != this.formData.Email) {
          this.postData.Email = this.formData.Email;
        }
      }
      if (this.showPaperlessCarrier) {
        if (this.formData.CellCarrierOrig != this.formData.CellCarrier) {
          this.postData.udCellPhoneCarrier = this.formData.CellCarrier;
        }
      }
      this.homeService.personalInfoUpdate(JSON.stringify(this.postData)).then((response: any) => {
        if (response.success) {
          this.confirmSettings();
        }
      });
    }
  }

  confirmSettings() {
    var firstRadio = this.formData.ElectronicPaystubConsent == "1" ? true : false;
    var secondRadio = this.formData.W2DocumentConsent == "1" ? true : false;
    var thirdRadio = this.formData.C1095DocumentConsent == "1" ? true : false;
    this.homeService.setDocConsent(this.formData.CellPhone, this.formData.Email, firstRadio, secondRadio, thirdRadio, this.formData.optOutSMS).then((response: any) => {
      if (response.success) {
        this.userAction = "confirm";
        this.activeModal.close();
      }
    });
  }

  updateCellPhone(data: string) {
    this.formData.CellPhone = data;
  }

}



